import Config from 'conf';
import { Logger } from 'data/common';
import eventsProducts from '../eventsSocket';

const { EventEmitter } = require('events');
const util = require('util');

let middleware_socket = null,
    io = require('socket.io-client'),
    socket_connected = false,
    middleware_config = {
        host: null,
        options: {},
        port: null,
        protocol: 'http'
    };

function SocketMiddleware(_dispatch, _getState, token) {
    return initConnexion.call(this, _dispatch, _getState, token);
}

const initConnexion = function initConnexion(_dispatch, _getState, token) {
    if (_dispatch && _getState && token) {
        EventEmitter.call(this);
        this.dispatch = _dispatch;
        this.getState = _getState;

        this.timeout_connexion = setTimeout(() => {
            middleware_socket = null;

            this.emit('cnx_error', 'timeout_connexion');
            this.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: 'disconnected' });
        }, Config.timeout_socket);

        this.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: 'pending' });
        this.socket = io(middleware_config.protocol + '://' + middleware_config.host + ':' + middleware_config.port, {
            timeout: 10000,
            ...middleware_config.options,
            query: 'clientType=tester&authid=' + token
        });

        Logger.debug(
            'TESTBENCH : Lancement de la connexion au Middleware ' +
                middleware_config.protocol +
                '://' +
                middleware_config.host +
                ':' +
                middleware_config.port,
            {
                timeout: 10000,
                ...middleware_config.options,
                query: 'type=client&authid=' + token
            }
        );
        let eventsSocket = eventsProducts(this);

        Object.keys(eventsSocket).map(fctKey => {
            this[fctKey] = eventsSocket[fctKey];
        });

        this.bindSocketEvents();
    }
};
util.inherits(SocketMiddleware, EventEmitter);

SocketMiddleware.prototype.socketEmit = function(event, params) {
    if (this.socket && socket_connected) {
        try {
            this.socket.emit(event, params);
            Logger.debug('TESTBENCH : Socket Event Emitted "' + event + '" --->', params);
        } catch (e) {
            Logger.debug('TESTBENCH : Error emit socket event "' + event + '"', e.message);
            throw e;
        }
    } else {
        throw new Error('middlewareConnectionBreak');
    }
};

SocketMiddleware.prototype.bindSocketEvents = function() {
    let self = this;

    if (!self.socket) {
        Logger.debug("TESTBENCH : Problème, la socket n'existe pas vraiment !");
        return false;
    }

    this.socketOn('error', function() {
        if (self.timeout_connexion) clearTimeout(self.timeout_connexion);
        const error_code = arguments[0].message || arguments[0];
        Logger.debug('TESTBENCH : Error Middleware', error_code);
        self.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: 'disconnected' });
    });

    this.socketOn('connect', function() {
        socket_connected = true;
        clearTimeout(self.timeout_connexion);
        self.timeout_connexion = null;
        Logger.debug("TESTBENCH : L'application vient de se connecter au middleware TESTBENCH");
        self.emit('connected');
        self.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: 'connected' });
    });

    this.socketOn('disconnect', function() {
        socket_connected = false;
        Logger.debug("TESTBENCH : L'application vient de se déconnecter du middleware TESTBENCH");
        self.emit('disconnect');
        self.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: 'disconnected' });
    });
};

SocketMiddleware.prototype.socketOn = function socketOn(event, callback) {
    if (this.socket) {
        this.socket.on(event, callback);
    }
};

SocketMiddleware.prototype.disconnect = function() {
    try {
        if (this.socket) {
            this.socket.disconnect();
        } else {
            Logger.debug('TESTBENCH : Impossible de déconnecter la socket');
        }
    } catch (e) {
        Logger.warn(`TESTBENCH : ${e}`);
    }
    this.socket = null;
};

SocketMiddleware.prototype.destroy = function() {
    try {
        Logger.debug('TESTBENCH : Destruction socketMiddleware');
        this.dispatch({ type: 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE', state: null });
        this.disconnect();
        middleware_socket = null;
    } catch (e) {
        Logger.warn(`TESTBENCH : ${e}`);
    }
};

export default function(dispatch, getState, token, _middleware_config) {
    if (_middleware_config) {
        middleware_config = _middleware_config;
    }
    if (!middleware_socket && dispatch && token) {
        middleware_socket = new SocketMiddleware(dispatch, getState, token);
        Logger.debug('TESTBENCH : Instanciation de la socket');
    }

    return middleware_socket;
}



// WEBPACK FOOTER //
// ./environments/testbench/common/SocketMiddleware.js